
import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ClientiApi, GetDipendenzeRequest, GetDipendenzaByIdRequest} from "../data/apis/ClientiApi";

export function dipendenzeDataSource(idCliente: string) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
            const api = new ClientiApi(apiConfiguration);
            
            const request: GetDipendenzeRequest = {
                idCliente: idCliente
            };

            return api.getDipendenze(request);
        },

        insert: (values) => {
            const api = new ClientiApi(apiConfiguration);

            return api.insertDipendenza({
                idCliente:idCliente,
                dipendenzaCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new ClientiApi(apiConfiguration);
            return api.updateDipendenza({
                idCliente:idCliente,
                idDipendenza: key,
                dipendenzaUpdateDTO: values           
            });
        },

        remove: (key) => {
            const api = new ClientiApi(apiConfiguration);
            return api.deleteDipendenza({
                idCliente: idCliente,
                idDipendenza:key
            });
        }
        
    });
}